

import { Icon, ListItemIcon, ListItemText, MenuItem, MenuList } from "@mui/material"
import { TMenuItemRelatorioProps } from "../vendas.model"


const MenuItemAgrupado = (props: TMenuItemRelatorioProps) => {
    const {
        canVisualizar = true,
        canImprimirRomaneio = true,
    } = props.acoes ?? {};

    return (
        <MenuList>
            <MenuItem
                key="menu-item-agrupado-visualizar-pedido"
                id="menu-item-agrupado-visualizar-pedido"
                disabled={!canVisualizar}
                onClick={() => props.onVisualizar(props.itemRef.current!.uuidPedido, props.itemRef.current!.numeroPedido)}
            >
                <ListItemIcon>
                    <Icon className="fa-solid fa-eye" sx={{ fontSize: "18px", width: '20px' }} />
                </ListItemIcon>
                <ListItemText>Visualizar</ListItemText>
            </MenuItem>

            <MenuItem
                    key="menu-item-agrupado-romaneioVenda"
                    id="menu-item-agrupado-romaneioVenda"
                    disabled={!canImprimirRomaneio}
                    onClick={() => props.onImprimirRomaneio!(props.itemRef.current!.uuidPedido)}
                >
                    <ListItemIcon>
                        <Icon className="fa-solid fa-print" sx={{ fontSize: "18px", width: '20px' }} />
                    </ListItemIcon>
                    <ListItemText>Imprimir romaneio</ListItemText>
            </MenuItem>
        </MenuList>
    )
}

export default MenuItemAgrupado
